import { ImagePathWithRenditions } from './ImageTypes';

export type AuthorLinkedContentPages = {
  name: string;
  author: string;
  contentPagesFetchUrl: string;
};

export type AuthorLinkedContentPage = {
  tags: Array<string>;
  image: ImagePathWithRenditions;
  title: string;
  shortDescription: string;
  fileReference: string;
  url: string;
};

export type AuthorLinkedProduct = {
  productCode: string;
  colorId: string;
};
